import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedClass: cacheLs.get_class()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
